import produce from 'immer';

import {
  FETCH_AUDIT_TRAILS_LIST_FAILURE,
  FETCH_AUDIT_TRAILS_LIST_SUCCESS,
  FETCH_RULE_JOB_AUDIT_LIST_FAILURE,
  FETCH_RULE_JOB_AUDIT_LIST_SUCCESS,
} from '@actions/auditTrails';

const initialState: IAuditTrailsStore = {
  count: null,
  auditTrails: null,
  ruleJobAudit: null,
  error: null,
};

export default (state: IAuditTrailsStore = initialState, action: any) =>
  produce(state, (draftState: IAuditTrailsStore) => {
    switch (action.type) {
      case FETCH_AUDIT_TRAILS_LIST_SUCCESS:
        draftState.auditTrails = action.response;
        draftState.error = null;

        return;

      case FETCH_AUDIT_TRAILS_LIST_FAILURE:
        draftState.error = action.error;

        return;

      case FETCH_RULE_JOB_AUDIT_LIST_SUCCESS:
        draftState.ruleJobAudit = action.response;
        draftState.error = null;

        return;

      case FETCH_RULE_JOB_AUDIT_LIST_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
